// src/apis/auth.js
import api from "../services/api";

// Auth endpoints (no token required)
export const signupUser = async (data) => {
  return api.post("/api/auth/signup", data);
};

export const loginUser = async (data) => {
  return api.post("/api/auth/login", data);
};

export const sendLoginOtp = async (data) => {
  return api.post("/api/auth/send-login-otp", data);
};

export const verifyLoginOtp = async (data) => {
  return api.post("/api/auth/verify-login-otp", data);
};

export const loginUserWithGoogle = async (data) => {
  return api.post("/api/auth/googleLogin", data);
};

export const sendResetOtp = async (data) => {
  return api.post("/api/auth/send-reset-otp", data);
};

export const resetPassword = async (data) => {
  return api.post("/api/auth/reset-password", data);
};

/** Get current user (for Profile when user not in localStorage) */
export const getCurrentUser = async () => {
  return api.get("/api/auth/me");
};
